var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.049,
    height: 14,
    viewBox: "0 0 14.049 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23439",
    "data-name": "Path 23439",
    d: "M-14047.432,1517.3h-.08a.761.761,0,0,1-.535-.221.74.74,0,0,1-.219-.606l.383-3.733a1.636,1.636,0,0,1,.475-1l8.048-8.052a1.668,1.668,0,0,1,1.063-.388,1.65,1.65,0,0,1,1.133.448l2.454,2.455a1.582,1.582,0,0,1,.06,2.231l-8.054,8.055a1.647,1.647,0,0,1-1,.47Zm6.189-9.615h0l-5.182,5.124-.264,2.894,2.895-.271,5.159-5.14-2.608-2.606Zm2.925-2.972h0l-1.931,1.981,2.585,2.587,1.983-1.934-2.638-2.635Z",
    transform: "translate(14048.27 -1503.299)",
    fill: "#fff",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.9864b1883ae42cb346d8267106745ea9.svg";
export { ForwardRef as ReactComponent };